// extracted by mini-css-extract-plugin
export default {"right-section":"rightSection_right-section__KClxO","master-body":"rightSection_master-body__Iw40j"};